import type { JobStatus } from '../types/job';

/**
 * Configuration for job statuses including display labels and styling.
 * All consumers (backend + frontend) should import from this shared module.
 */
export const JOB_STATUS_CONFIG: Record<
  JobStatus,
  { label: string; className: string }
> = {
  quote_requested: {
    label: 'Quote Requested',
    // Action needed: send quote
    className: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  },

  estimate_sent: {
    label: 'Estimate Sent',
    // Waiting on client
    className: 'bg-blue-100 text-blue-800 border-blue-300',
  },

  awarded: {
    label: 'Awarded',
    // Action needed: schedule / start work
    className: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  },

  not_awarded: {
    label: 'Not Awarded',
    // Inactive, no action
    className: 'bg-gray-100 text-gray-800 border-gray-300',
  },

  in_progress: {
    label: 'In Progress',
    // Normal active work
    className: 'bg-blue-100 text-blue-800 border-blue-300',
  },

  completed: {
    label: 'Completed',
    // Work is done, billing workflow begins
    className: 'bg-green-100 text-green-800 border-green-300',
  },
};


/**
 * Helper function to get the label for a job status.
 */
export function getJobStatusLabel(status: JobStatus): string {
  return JOB_STATUS_CONFIG[status].label;
}

/**
 * Array of job status options for use in dropdowns/selects.
 * Each option has a value (the status code) and a label (human-readable).
 */
export const JOB_STATUS_OPTIONS = Object.entries(JOB_STATUS_CONFIG).map(
  ([value, config]) => ({
    value: value as JobStatus,
    label: config.label,
  })
);
